import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Result from "@/pages/Result";
import Admin from "@/pages/Admin";
import Glowy from "@/components/Glowy";

function App() {
  return (
    <div className="App font-body gs-grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/r/:id" element={<Result />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Glowy />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
